import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Checkbox } from 'antd';

import './CompanyModulesView.style.less';

class CompanyModulesView extends Component {
  renderItems = (text, record) => (
    <Checkbox
      checked={text}
      onChange={event => this.onCheckboxChange(event, record)}
      disabled={record.viewAllDisabled || false}
    />
  );

  onCheckboxChange = (event, record) => {
    this.props.onSelectPermission(record, event.target.checked);
  };

  getColumns() {
    return [
      {
        title: 'Allowed Modules',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'View All',
        dataIndex: 'view_all',
        key: 'view_all',
        render: this.renderItems.bind(this),
      },
    ];
  }

  render() {
    const { availableModules, placeholder } = this.props;
    const columns = this.getColumns();
    const selectedModules = availableModules.filter(x => x.checked === true);

    return (
      <div id="company-modules-view">
        {selectedModules.length > 0 ? (
          <Table
            dataSource={selectedModules}
            columns={columns}
            pagination={false}
            rowKey="id"
          />
        ) : (
          <div className="placeholder">{placeholder}</div>
        )}
      </div>
    );
  }
}

CompanyModulesView.propTypes = {
  onSelectPermission: PropTypes.func,
  availableModules: PropTypes.array,
  placeholder: PropTypes.string,
};

CompanyModulesView.defaultProps = {
  placeholder: 'No Data',
};

export default CompanyModulesView;
